"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var useFetch_1 = require("./useFetch");
function Fetch(_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    var request = useFetch_1.default(props);
    return children(request);
}
exports.default = Fetch;
